import React from 'react'

const Spinner = () => {
	return (
		<div className='d-flex justify-content-center'>
			<div className='spinner-border text-white' role='status'>
				<span className='sr-only'>Завантаження...</span>
			</div>
		</div>
	)
}

export default Spinner
